@if(locatedStockResource){
  <div class="flex flex-col h-full min-h-0">
    <dx-data-grid #grid (refreshEmit)="refresh()" class="flex-1 min-h-0" [glamResource]="locatedStockResource!">
      <dxi-column dataField="quantity" dataType="number" [caption]="'entity.container.quantity' | translate | ucfirst"></dxi-column>
      <dxi-column dataField="formatCode" [caption]="'entity.container.format' | translate | ucfirst"></dxi-column>
      <dxi-column dataField="batch" [caption]="'entity.batch.batch' | translate | ucfirst" cellTemplate="batch">
        <div *dxTemplate="let data of 'batch'" class="flex items-center gap-2">
          <a class="hover:underline cursor-pointer" (click)="navigateToBatchEditor(data.data.goodId)">{{ data.value }}</a>
          <span *ngIf="batchStateColor(data.data.productBatchStateId) as stateColor"
                class="w-2.5 h-2.5 shrink-0 rounded-full"
                [style.backgroundColor]="stateColor"
                [title]="batchStateName(data.data.productBatchStateId)"></span>
        </div>
      </dxi-column>
      <dxi-column dataField="warehouseName" [caption]="'entity.product.warehouse' | translate | ucfirst"></dxi-column>
      <dxi-column dataField="locationCode" [caption]="'entity.container.containerLocation' | translate | ucfirst" cellTemplate="location">
        <div *dxTemplate="let data of 'location'" class="hover:underline cursor-pointer">
          <a (click)="navigateToLocationEditor(data.data.locationId)">{{ data.value }}</a>
        </div>
      </dxi-column>
      <dxi-column cellTemplate="containerCode" dataField="containerCode" [caption]="'entity.container.containerId' | translate | ucfirst">
        <div *dxTemplate="let data of 'containerCode'" class="hover:underline cursor-pointer">
          <a (click)="navigateToContainerEditor(data.data.containerId)">
            {{ data.value }}
          </a>
        </div>
      </dxi-column>
      <dxi-column dataField="batchExpirationDate" [caption]="'entity.batch.expirationDate' | translate | ucfirst" dataType="date"/>
      <dxi-column dataField="batchFirstEntryDate" [caption]="'entity.batch.firstEntryDate' | translate | ucfirst" dataType="date"/>
    </dx-data-grid>
    <div class="stock-summary flex flex-row justify-end gap-2 w-100 py-2 font-medium">
      <span>{{'common.records' | translate | ucfirst}}: {{recordCount}}</span>
      <span>|</span>
      <span>{{'common.total' | translate | ucfirst}}: {{totalDisplay}}<ng-container *ngIf="formatCode">&nbsp;{{formatCode}}</ng-container></span>
    </div>
  </div>
}
